export const ChainNames = {
  1: "Mainnet",
  3: "Ropsten",
};
